<div [formGroup]="form" class="modalForm">
  <div class="flex flex-column gap-2 mb-3">
    <label for="label" class="font-semibold w-full"
      >{{ "butler_programming.rule_chains.table.label" | translate }}*</label
    >
    <input pInputText id="label" formControlName="label" autocomplete="off" />
  </div>
  <div class="flex flex-column gap-2 mb-3">
    <label for="active" class="font-semibold w-full">{{
      "butler_programming.rule_chains.table.active" | translate
    }}</label>
    <p-checkbox formControlName="active" inputId="active" [binary]="true" />
  </div>
  <div class="flex flex-column gap-2 mb-3" style="grid-column: 1 / 3">
    <label for="notes" class="font-semibold w-full">{{
      "butler_programming.rule_chains.table.notes" | translate
    }}</label>
    <textarea rows="5" cols="30" pInputTextarea formControlName="notes" [autoResize]="true"> </textarea>
  </div>

  <div class="flex justify-content-end gap-2 dialogBtnGroup">
    <app-button buttonText="common.cancel" (click)="closeDialog()"></app-button>
    <app-button
      buttonText="common.save"
      [disabled]="!form.valid || requestStarted()"
      (click)="save()"
      [loading]="requestStarted()"
    ></app-button>
  </div>
</div>
